import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ChangeDetectionStrategy } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
    selector: 'app-grade-matrix',
    templateUrl: './grade-matrix.component.html',
    styleUrls: ['./grade-matrix.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class GradeMatrixComponent implements OnInit {
    @Input() cdmsFormGroup: UntypedFormGroup;

    gradeMatrixData: any[] = [];
    displayedColumns: string[] = ['gradeLevel', 'minScore', 'maxScore', 'status'];

    constructor() {}

    ngOnInit(): void {
        this.loadGradeMatrixData();
    }

    loadGradeMatrixData(): void {
        // Load grade matrix data
        this.gradeMatrixData = [
            { gradeLevel: 'Grade A', minScore: 90, maxScore: 100, status: 'Active' },
            { gradeLevel: 'Grade B', minScore: 80, maxScore: 89, status: 'Active' },
            { gradeLevel: 'Grade C', minScore: 70, maxScore: 79, status: 'Active' },
            { gradeLevel: 'Grade D', minScore: 60, maxScore: 69, status: 'Active' },
            { gradeLevel: 'Grade F', minScore: 0, maxScore: 59, status: 'Inactive' },
        ];
    }

    editGrade(element: any): void {
        // Implement edit functionality
    }

    deleteGrade(element: any): void {
        // Implement delete functionality
    }

    addGrade(): void {
        // Implement add grade functionality
    }
}
